import React from "react";
import { useTranslation } from "react-i18next";

export function StatusBadge({ status }) {
  const { t } = useTranslation();
  return (
    <span
      data-testid={`status-${status}`}
      className={`status-${status} inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold tracking-wide`}
    >
      {t(`statuses.${status}`)}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const { t } = useTranslation();
  return (
    <span className={`priority-${priority} text-[11px] font-semibold uppercase tracking-wider`}>
      {t(`priorities.${priority}`)}
    </span>
  );
}
